module.exports = function (proxy) {
  if (proxy == "Web" || proxy == "Vue") return "mdi-earth";
  if (proxy == "iOS-Customer") return "mdi-apple";
  if (proxy == "Android") return "mdi-android";
  return proxy;
}